<!-- <div bsModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered"> -->



<div class="modal-content">
  <div class="modal-header bg-primary text-white ">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close text-white" data-bs-dismiss="modal" aria-label="Close"
      (click)="dismissModal()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-5">
        <div class="mb-3">
          <label>Tower</label>

          <ng-select [items]="towerList" bindLabel="tower" bindValue="id" id="type" [multiple]="true"
            [closeOnSelect]="false" [hideSelected]="false" placeholder="Select tower" (change)="towerChange($event)">

            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                <span class="ng-value-label" *ngIf="item?.tower">{{ item?.tower }}</span>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">+ {{ items.length - 1 }} more</span>
              </div>
            </ng-template>
          </ng-select>

        </div>
      </div>
      <div class="col-lg-5">
        <div class="mb-3">
          <label>Block</label>

          <ng-select [items]="blockList" bindLabel="block" bindValue="id" id="type" [multiple]="true"
            [closeOnSelect]="false" [hideSelected]="false" placeholder="Select block" (change)="blockChange($event)">
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                <span class="ng-value-label" *ngIf="item?.block">{{ item?.block }}</span>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">+ {{ items.length - 1 }} more</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="col-lg-2" style="top: 30px;">
        <div class="mb-3">
          <button type="button" class="btn btn-primary" (click)="filterChange()">
            Filter</button>
        </div>
      </div>
    </div>
    <form class="form-horizontal" [formGroup]="createMappingForm">



      <div class="mb-3">
        <label>Utility Measuring Device(Umd)<span class="required">*</span></label>
        <!--   <ng-select [items]="unmappedUmdList" bindLabel="macAddress" bindValue="id" formControlName="utilityId" id="type"
          [multiple]="true" [(ngModel)]="selectedUmds" [closeOnSelect]="false" [hideSelected]="true"
          placeholder="Select MAC Addresses" [deselectOnClick]="true"  [selectableGroup]="true" [selectableGroupAsModel]="false">

          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ item?.macAddress }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </ng-template>
          
          <ng-template ng-header-tmp>
            <div class="select-all-option" (click)="selectedAll()">
              <input type="checkbox" [checked]="isAllSelected()" /> Select All
            </div>
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items.slice(0,2)">
              <span class="ng-value-label" *ngIf="item?.macAddress">{{ item?.macAddress }}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
            </div>
          </ng-template>
        </ng-select> -->

        <!--   <ng-select [items]="unmappedUmdList" bindLabel="macAddress" bindValue="id" [multiple]="true"
          [(ngModel)]="selectedUmds" [closeOnSelect]="false" [hideSelected]="true" placeholder="Select MAC Addresses"
          [deselectOnClick]="true" formControlName="utilityId" id="type">
         
          <ng-template ng-header-tmp>
            <div class="select-all-option">
              <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
              <label>Select All</label>
            </div>
          </ng-template>

         
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items.slice(0, 2)">
              <span class="ng-value-label">{{ item?.macAddress }}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
            </div>
          </ng-template>

          
          <ng-template ng-option-tmp let-item="item">
            <div class="option-checkbox">
              <input type="checkbox" [ngModel]="isSelected(item)" (ngModelChange)="toggleItem(item)" />
              {{ item.macAddress }}
            </div>
          </ng-template>
        </ng-select> -->

        <ng-select [items]="unmappedUmdList " bindLabel="macAddress" bindValue="id"
          formControlName="utilityId" id="type" [multiple]="true" [(ngModel)]="selectedUmds" [closeOnSelect]="false"
          [hideSelected]="false" placeholder="Select MAC Addresses" (search)="onSearch($event)"
          (remove)="onRemove($event)" (change)="onChange($event)">

          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ item?.macAddress }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </ng-template>


          <ng-template ng-header-tmp>
            <div class="select-header-options">
              <div class="select-all-option" (click)="selectAllFiltered()" *ngIf="searchActive">
                <input type="checkbox" [checked]="isFilteredSelected()" />
                <label style="margin-left: 7px">Select All</label>
              </div>
              <div class="select-all-option" (click)="selectAllFullList()" *ngIf="!searchActive">
                <input type="checkbox" [checked]="isAllSelected()" />
                <label style="margin-left: 7px">Select All </label>
              </div>
            </div>
          </ng-template>




          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items.slice(0,2)">
              <span class="ng-value-label" *ngIf="item?.macAddress">{{ item?.macAddress }}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="ng-option-item" style="display: flex; justify-content: space-between; align-items: center;">
              <span class="ng-option-label">{{ item?.macAddress }}</span>
              <span class="ng-clear-icon" *ngIf="isSelected(item)" (click)="clearOption(item)" aria-hidden="true"
                style="margin-left: 10px;">×</span>
            </div>
          </ng-template>


        </ng-select>

        <!--  <ng-select [items]="unmappedUmdList" placeholder="All Projects" bindLabel="macAddress" bindValue="id"
          [(ngModel)]="selectedUmds" (change)="revenuDataOnProject()" [multiple]="true" [deselectOnClick]="true">


          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ item?.macAddress }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </ng-template>


          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngIf="items.length > 0">
              <span class="ng-value-label">{{ items[0]?.macAddress }}</span>
              <span class="ng-value-icon right" (click)="clear(items[0])" aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 1">
              <span class="ng-value-label">{{ items[1]?.macAddress }}</span>
              <span class="ng-value-icon right" (click)="clear(items[1])" aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ng-option-item">
              <span class="ng-option-label">{{ item?.macAddress }}</span>


              <span class="ng-clear-icon" *ngIf="isSelected(item)" (click)="clearOption(item)"
                aria-hidden="true">×</span>
            </div>
          </ng-template>

        </ng-select> -->


        <!--  <ng-select [items]="unmappedUmdList" bindLabel="macAddress" bindValue="id" [multiple]="true"
          [(ngModel)]="selectedUmds" [closeOnSelect]="false" [hideSelected]="true" placeholder="Select MAC Addresses"
          [deselectOnClick]="true" formControlName="utilityId" id="type">

         
          <ng-template ng-header-tmp>
            <div class="select-all-option" style="display: flex; align-items: center;">
              <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
              <label>Select All</label>
            </div>
          </ng-template>

        
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items.slice(0, 2)">
              <span class="ng-value-label">{{ item?.macAddress }}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
            </div>
          </ng-template>

          
          <ng-template ng-option-tmp let-item="item">
            <div class="option-checkbox">
              <input type="checkbox" [checked]="isSelected(item)" (ngModelChange)="toggleItem(item)" />
              {{ item.macAddress }}
            </div>
          </ng-template>

        </ng-select> -->




        <!-- <ng-select [items]="unmappedUmdList" [multiple]="true" bindLabel="macAddress" bindValue="id" groupBy="group"
          [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="false" [(ngModel)]="selectedUmds">
         
          <ng-template ng-optgroup-tmp let-item="item">
            <div class="custom-optgroup-header">
              <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
              <label>Select All</label>
            </div>
          </ng-template>

          
          <ng-template ng-option-tmp let-item="item">
            <div class="custom-option">
              <input type="checkbox" [checked]="isSelected(item)" (change)="toggleItem(item)" />
              {{ item.macAddress }}
            </div>
          </ng-template>
        </ng-select> -->




        @if(submitted && createMappingForm.controls['utilityId'].errors) {
        <div class="invalid-feedback">
          @if(createMappingForm.controls['utilityId'].errors['required']) {
          <div>{{Mapping_Validations.utilityId.required}}</div>}
        </div>}

      </div>





    </form>


  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary waves-effect waves-light" (click)="CreateMapping('Create')">Save
      Mapping</button>
  </div>
</div><!-- /.modal -->
<!-- </div>
</div> -->